module.exports = __webpack_public_path__ + "static/media/protection-silicone.94c2b44a.png";